import React from 'react';
import { Row } from 'antd';
import {
    ShowTariffPackageInstanceCards,
    ShowTariffPackageInstanceInfo,
    ShowTariffPackageInstanceStatistics,
    ShowTariffPackageInstanceUsages,
} from './';
import Styles from '../../styles/m_itemCardStyles.less';

export const ShowTariffPackageInstance: React.FC = () => {
    return (
        <div className={Styles.main}>
            <Row>
                <ShowTariffPackageInstanceInfo />
                <ShowTariffPackageInstanceUsages />
                <ShowTariffPackageInstanceStatistics />
                <ShowTariffPackageInstanceCards />
            </Row>
        </div>
    );
};
